import React from 'react';

import { LayoutModel, ModelCategory } from '@paragon/contract-library';
import { DataRow, getQuantityMap, isDataRow } from '@paragon/layout-models';

import { getTotalComponentCount } from '../../store/selectors/projectMetrics';
import { useAppSelector } from '../hooks';

export function ProjectGridQuantityCell(props: { readonly row: DataRow<LayoutModel> }) {
  const { row } = props;

  const quantity = useAppSelector((state) => {
    if (row.item.category === ModelCategory.Project) {
      return getTotalComponentCount(state)(row.item.guid);
    }

    if (row.parent && isDataRow(row.parent)) {
      return getQuantityMap(state)[row.item.guid]?.[(row.parent.item as LayoutModel).guid] ?? null;
    }

    return null;
  });

  return quantity == null ? null : <span>{quantity}</span>;
}
